import type { Schemas } from '#shopware'
import { mediaIncludes } from './media'
import { productCardIncludes } from './product'
import { productListingIncludes } from './productListing'

export const cmsSlotIncludes: Schemas['Includes'] = {
    cms_slot: [
        'type',
        'slot',
        'listing',
        'products',
        'data',
        'media',
        'config',
        'translated',
        'extensions',
        'a4gConfig',
        'swagCmsExtensionsForm',
        'categoryTree',
    ],
    cms_product_listing: ['listing'],
    ...mediaIncludes,
    ...productCardIncludes,
    ...productListingIncludes,
}

const cmsBlockFields = [
    'type',
    'slots',
    'cssClass',
    'backgroundColor',
    'backgroundMedia',
    'backgroundMediaMode',
    'sectionPosition',
    'visibility',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'customFields.maxWidthCssClass',
    'customFields.columnRatio',
    'customFields.hideHeadline',
    'customFields.layout',
]

export const cmsBlockIncludes: Schemas['Includes'] = {
    cms_block: cmsBlockFields,
    ...cmsSlotIncludes,
    ...mediaIncludes,
}

const cmsSectionFields = [
    'type',
    'name',
    'sizingMode',
    'blocks',
    'cssClass',
    'backgroundColor',
    'backgroundMedia',
    'backgroundMediaMode',
    'mobileBehavior',
    'visibility',
]

export const cmsSectionIncludes: Schemas['Includes'] = {
    cms_section: cmsSectionFields,
    ...cmsBlockIncludes,
    ...mediaIncludes,
}

export const layoutCmsIncludes: Schemas['Includes'] = {
    cms_section: cmsSectionFields,
    cms_block: cmsBlockFields,
    cms_slot: ['type', 'config', 'data'],
    ...mediaIncludes,
}
